import Service from "../service";
import AuthService from "../AuthService";

const Patient = {
  getPatient(data) {
    return AuthService.get("/patient?page="+data.page+
      "&field="+data.field+
      "&sorttype="+data.sorttype+
      "&event_id="+data.event_id+
      "&area_id="+data.area_id+
      "&user_type_id="+data.user_type_id+
      "&province_id="+data.province_id+
      "&district_id="+data.district_id+
      "&name="+data.name+
      "&gender="+data.gender);
  },
  showPatient(event_id,order) {
    let res = AuthService.get('/patient_show?event_id='+event_id+'&order='+order);
    return res;
  },
  updatePatient(data) {
    return AuthService.post("/patient_update",data).then(res => {
    });
  },
  createPatient(data) {
    return AuthService.post("/patient", data);
  },
  deletePatient(id) {
    return AuthService.delete("/patient/" + id);
  },
  searchPatient(data){
    return AuthService.post('/search_patient',data);
  }
};

export default Patient;
